import { useContext } from 'react';
import { MEDIA_BUFFER_STATUSES } from '../../constants/MediaBufferStatus';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { MediaPlaybackBufferContext } from '../../context/MediaPlaybackBufferContext';
import { getParsedPlayerStatuses } from '../../utils/getParsedPlayerStatuses';
export const useControlsStatus = () => {
  const {
    status
  } = useContext(MediaPlaybackControlsContext);
  const {
    bufferStatus
  } = useContext(MediaPlaybackBufferContext);
  const {
    isLoaded,
    isError,
    isPaused
  } = getParsedPlayerStatuses(status);
  const isBuffering = bufferStatus === MEDIA_BUFFER_STATUSES.BUFFERING;
  return {
    isDisabled: !isLoaded || isBuffering,
    isError,
    isLoaded,
    isPaused,
    isBuffering,
    status
  };
};